import EConsentContext from '@/contexts/EConsentContext';
import { FC, useContext } from 'react';
import ServicesAustraliaConsentEConsentForm from './services-australia-consent/ServicesAustraliaConsentEConsentForm';
import ServicesAustraliaConsentStandardForm from './services-australia-consent/ServicesAustraliaConsentStandardForm';

const ServicesAustraliaConsentForm: FC = () => {
    const { userType } = useContext(EConsentContext);

    return userType
        ? <ServicesAustraliaConsentEConsentForm />
        : <ServicesAustraliaConsentStandardForm />;
};

export default ServicesAustraliaConsentForm;
